import UiState, { UiStateInterface } from './uiState';
import OrderList from '../Views/OrderList/store';
import BindNotice, { BindNoticeInterface } from './bindNotice';
import HasShare, { HasShareInterface } from './hasShare';
import GuideWeChat, { GuideWeChatStoreInterface } from './guideWeChat';
import Size, { SizeInterface } from './size';
import URLS from '../Constant/urls';
import { getStatusDataById } from '../Constant/statusBarData';
import { getInfoById } from '../Constant/filterBarData';
import invalidLoginCodeMap from '../Constant/invalidLoginCodeMap';
import * as loginUtil from '../Utils/loginUtil';
// import { LoginManager } from '../Utils/LoginManager';
import LoginManager from '../Utils/LoginManager';
// import { PerQavManager } from '../Utils/PerQavManager';
import PerfQav from '../Utils/perfQav';
import { qav } from '../Utils/qav';
import PPLogUtil from '../Utils/PPLogUtil';
import PopViewManager,{PopViewType} from '../Utils/PopViewManager'
import MoreButtonStore from "./moreButtonStore";
import { DeviceInfo } from 'qunar-react-native'
import getQueryParam from '../Utils/getQueryParam';

const { isWeb,isMini } = DeviceInfo

export interface RootStoreInterface {
    uiState: UiStateInterface;
    bindNotice: BindNoticeInterface;
    hasShare: HasShareInterface;
    guideWeChat: GuideWeChatStoreInterface;
    size: SizeInterface;
    orderlist: OrderList;

    pageName: string;
    actived?: boolean;
    // 增加其他store 需要的 needRefresh
    needRefresh: boolean;
    needCompareLogin?: boolean;
    perfQav?: PerfQav;
    loginManager?: LoginManager;
    hyId?: string;
    popViewManager?: PopViewManager;
    moreButtonStore?: MoreButtonStore;

    loginOutCallBack?: (isLoginInvalid: boolean) => void;
    loginInCallBack?: () => void;
    checkPopViewFunc?: () => void;

    onloginSuc?(): void;
    onloginSuccessCallBack?(): void;//订单登录成功回调，供行程内部订单回调使用
    onDataLoaded(loadType: string, data: any): void;
    onNetworkError(): void;
    initCallbackCreator(
        isCold: boolean,
        isFirstLoad: boolean
    ): (data: { showSuc: string; failReason: string; reqStart: number; reqEnd: number }) => void;
    changeStatus(statusFilter: string, businessId?: string): void;
    resetPage(businessId: string, isCold?: boolean, isFirstLoad?: boolean): void;
    autoBind(): void;

}

class RootStore implements RootStoreInterface {
    public pageName = 'order_rn_main';

    public actived = true;
    public uiState: UiStateInterface;
    public bindNotice: BindNoticeInterface;
    public hasShare: HasShareInterface;
    public guideWeChat: GuideWeChatStoreInterface;
    public size: SizeInterface;
    public orderlist: OrderList;
    // 增加其他store 需要的 needRefresh
    public needRefresh = false;
    public needCompareLogin = false;
    public perfQav: PerfQav;
    public loginManager: LoginManager;
    public hyId = 'cmn_order_rn';
    public popViewManager: PopViewManager;
    public moreButtonStore: MoreButtonStore;

    public loginOutCallBack: (isLoginInvalid: boolean) => void;
    public loginInCallBack: () => void;
    public onloginSuccessCallBack: ()=> void;

    public checkPopViewFunc: () => void;
    // PerQavManager
    public constructor() {
        this.uiState = new UiState(this);
        this.bindNotice = new BindNotice(this);
        this.hasShare = new HasShare(this);
        this.guideWeChat = new GuideWeChat(this);
        this.size = new Size(this);
        this.orderlist = new OrderList(
            {
                pageName: this.pageName,
                pageSize: 10,
                url: URLS.orderlist,
                method: 'POST',
                useCache: !isMini,
                needPerfQavLog: true,
                needFetchSeriveBtn: true,
                onNetworkError: this.onNetworkError,
                onDataLoaded: this.onDataLoaded,
                onloginSuc: this.onloginSuc,
                initCallbackCreator: this.initCallbackCreator
            },
            this
        );
        this.loginManager = new LoginManager();
        this.popViewManager = new PopViewManager();
        this.moreButtonStore = new MoreButtonStore(this);
    }
    public onloginSuc = () => {
        // if (this.uiState.filterBarTitle === '本地订单') {
        //     this.uiState.updateFilterBarTitle('全部订单');
        // }
        // 自动绑定本地订单
        this.autoBind();
        this.uiState.toggleShowLoginBar(false);
        this.onloginSuccessCallBack && this.onloginSuccessCallBack()
    };

    public onDataLoaded = async (loadType: string, data: any = {}) => {
        const { orderList = [], serverStatus } = data;

        if (invalidLoginCodeMap[serverStatus]) {
            // global.$loginSucCb = () => {
            this.loginManager.loginSucCb = () => {
                this.resetPage(this.uiState.businessId);
            };
        }

        if (loadType !== 'loadMore') {
            // share && share.hasShare(me, orderViewInstance);
            if (!isMini) {
                this.bindNotice.checkBindOrder(this.uiState.businessId, this.uiState.businessValue);
                if (!Boolean(isWeb && getQueryParam('fromChannel'))) {
                    this.hasShare.checkHasShare();
                }
            }
        }

        if (orderList.length > 0) {
            // 未登录，有本地订单，展示登录
            this.uiState.toggleShowLoginBar(!(await loginUtil.isLogin()));
        } else {
            this.uiState.toggleShowLoginBar(false);
        }
    };

    public onNetworkError = () => {
        this.uiState.toggleShowLoginBar(false);
    };

    public initCallbackCreator = (isCold = true, isFirstLoad: boolean) => {
        const { statusFilter, sourceFrom, businessId } = this.uiState;
        return (data: { showSuc: string; failReason: string; reqStart: number; reqEnd: number }) => {
            const { showSuc, failReason, reqStart, reqEnd } = data;
            qav({
                page: this.pageName,
                source: sourceFrom,
                operType: 'enter',
                ext: {
                    isCold,
                    filter: businessId,
                    status: statusFilter,
                    showSuc,
                    failReason
                }
            });
            // console.log('旧订单enter')

            if (isFirstLoad && reqStart && reqEnd) {
                // global.$perfQav.setReqStart(reqStart);
                // global.$perfQav.setReqEnd(reqEnd);
                this.perfQav.setReqStart(reqStart);
                this.perfQav.setReqEnd(reqEnd);
            }
        };
    };

    // 切换状态栏，修改了 uiState 和 orderList
    public changeStatus = (statusFilter: string, businessId?: string) => {
        const statusData = getStatusDataById(businessId || this.uiState.businessId, statusFilter);
        this.uiState.setStatusFilter(statusFilter);
        this.orderlist.setExtRequestParams(getStatusParams(statusData.value, statusData.title));
        // 有绑定微信提醒，重置
        this.guideWeChat.toggleShowGuideChat(statusFilter);
    };

    // 重置页面，只在初始化页面和切换筛选栏时会调用次函数
    public resetPage = async (
        businessId = this.uiState.businessId,
        isCold = true,
        isFirstLoad?: boolean
    ) => {
        const businessInfo = getInfoById(businessId);
        if (!businessInfo) {
            throw Error('传入的businessType有误，必须是以下值之一');
        }
        // 举例，如果是从【机票】的【待出票】切换到【火车票】，火车票没有 id 为 ticketing 的状态栏数据，那么就切换到火车票的all
        if (!getStatusDataById(businessId, this.uiState.statusFilter)) {
            this.changeStatus('all', businessId);
        } else {
            // 其他情况需要刷新queryScene
            this.changeStatus(this.uiState.statusFilter, businessId);
        }
        const { value: businessValue, title: businessName } = businessInfo;
        const isLogin = Boolean(await loginUtil.isLogin());

        const nextBusinessName =
            businessName === '全部' ? (isLogin ? '全部订单' : '全部订单') : businessName;

        this.uiState.updateFilterBarTitle(nextBusinessName);
        this.uiState.setBusinessValue(businessId === 'bus' && !isLogin ? 'bus' : businessValue);
        this.uiState.setBusinessId(businessId);
        this.uiState.setIsLogin(isLogin);

        // 每次切换，必然要重新设置请求参数
        this.orderlist.setRequestParams({
            businessTypes: this.uiState.businessValue,
            userNameQuery: isLogin,
            localQuery: !isLogin,
            unbindQuery: !isLogin,
            source: this.uiState.sourceFrom
        });

        // 打开/关闭删除功能
        this.orderlist.toggleDeleteable(isLogin);

        // 调用init方法，获取数据
        this.orderlist.scrollTopAndInit(isCold, isFirstLoad);
    };

    // 订单页登录后 本地订单自动绑定
    public autoBind = async () => {
        try {
            const response = await fetch(
                {
                    url: URLS.autoBind,
                    method: 'post',
                    body: {
                        businessTypes: this.uiState.businessValue,
                        unbindQuery: true,
                        autoBindSource: 'wirelist'
                    },
                    requestType: 'form'
                },
                (abort: () => any) => {},
                this.hyId
            );
            const { status, data } = response;
            if (status === 0 && data && data.length > 0) {
                // 延时一秒 等待后端同步数据
                setTimeout(() => {
                    this.resetPage(this.uiState.businessId);
                }, 1000);
            } else {
                this.resetPage(this.uiState.businessId);
            }
        } catch (err) {
            this.resetPage(this.uiState.businessId);
        }
    };
}

const getStatusParams = (data: string, title: string) => {
    if (data === 'readygo') {
        return {
            orderCenterStatus: '',
            queryScene: 3
        };
    }
    if (data === 'needComment') {
        return {
            businessTypes: 'hotel,hotel_sight,travel',
            orderCenterStatus: '',
            queryScene: 4
        };
    }
    // 全部订单时退款/售后
    if (title === '退款/售后') {
        return {
            orderCenterStatus: '1010,1020,1030,1040,1050,200010,200020,100100,700030,600010',
            queryScene: 5
        };
    }
    return {
        orderCenterStatus: data || '',
        queryScene: ''
    };
};

// export default new RootStore();
export default RootStore;
